export const liveTransaction = {
  liveTransaction: "Live Transaction",
  search: "Search",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  action: "Action",
  selectAction: "Select Action",
  selectFrom: "Select From",
  cancel: "Cancel",
  filter: "Filter",
  amount: "Amount",
  date: "Date",
  user: "User",
  approver: "Approver",
  approvedBy: "Approved By",
  slipTime: "Slip Time",
  deposit: "Deposit",
  withdraw: "Withdraw",
  payDuty: "Payduty",
  rtb: "RTB",
  admin: "Admin",
  system: "System",
  status: "Payment Status",
};
